import React, { useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import ChipComp from "components/common/Chip";

import { getEmployeeLeavesDataForCustomer } from "services/useTimeoffService";
import { getLeaveBreakdownDetails } from "components/Screens/CustomerOnboarding/helpers";

function LeaveBreakdownChips({
  employeeId = 0,
  leaveType = "",
  pending = false,
  collapsed = true,
  scheduleTextClass = "",
  leavesApplied = 0,
}) {
  const [employeeLeavesData, setEmployeeLeavesData] = useState(null);

  const { anniversaryBasedTimeOff } = useFlags();

  const fetchEmployeeLeavesDataForCustomer = async () => {
    try {
      const res = await getEmployeeLeavesDataForCustomer(employeeId, anniversaryBasedTimeOff);
      setEmployeeLeavesData(res?.payload?.data);
    } catch (error) {
      console.error("Error fetching employee leave data:", error);
    }
  };

  useEffect(() => {
    if (employeeId) {
      fetchEmployeeLeavesDataForCustomer();
    }
  }, [employeeId, anniversaryBasedTimeOff]);

  const { paid, unpaid, advance, advanceAllowed } = getLeaveBreakdownDetails(
    employeeLeavesData,
    leaveType,
    leavesApplied
  );

  return (
    <>
      <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass} id="breakdown">
        Breakdown
      </div>
      <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
        <ChipComp variant="outlined" id="no-of-leaves" labelClass="para-body-s-regular" label={`${paid} Paid`} />
        {advanceAllowed && (
          <ChipComp
            variant="outlined"
            id="no-of-leaves"
            labelClass="para-body-s-regular"
            label={`${advance} Advance`}
          />
        )}
        {!advanceAllowed && unpaid > 0 && (
          <ChipComp variant="outlined" id="no-of-leaves" labelClass="para-body-s-regular" label={`${unpaid} Unpaid`} />
        )}
      </div>
    </>
  );
}

export default LeaveBreakdownChips;
